import { FormikValues, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

import UserAddTitleAndInput from "../UserAddTitileAndInput";
import FormStepTitle from "../../../../common/form/Steps/FormStepTitle";
import DropdownField from "../../../../common/form/dropdown/DropdownField";

import { userRoles } from "../../../../../constants/user";
import styles from "./../../styles/styles.module.scss";
import { useParams } from "react-router-dom";
import { districts } from "../../../../../constants/patient";
import { Checkbox } from "@mui/material";
import { Box } from "@mui/material";

type Props = {
  inputHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const sampleRolesData = [
  // {
  //   name: userRoles.SUPER_ADMIN,
  //   label: "Super Admin",
  // },
  {
    name: userRoles.SURGEON,
    label: "MS",
  },
  {
    name: userRoles.D_C,
    label: "Director in Chief",
  },
  {
    name: userRoles.STAFF,
    label: "Medanta Staff",
  },
];

const UserFormStepOne: React.FC<Props> = ({ inputHandler }) => {
  const { values, setFieldValue, setFieldTouched } =
    useFormikContext<FormikValues>();

  const { id } = useParams();

  const [roles] = useState(sampleRolesData);

  const roleInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value);
    if (e.target.value !== userRoles.SURGEON) {
      setFieldValue("district", "");
      setFieldTouched("district", false);
    }
  };

  return (
    <>
      <FormStepTitle title="User Details" required />
      <UserAddTitleAndInput
        title="User Name*"
        name="name"
        placeholder="User Name"
      />

      <h5 className={styles.h5}>Role</h5>
      <DropdownField
        name="role"
        label="Role"
        dropDownList={roles}
        itemFieldValue="name"
        itemFieldLabel="label"
        value={values?.role}
        onChange={roleInputHandler}
        disabled={!!id}
        sx={{
          "& .MuiInputBase-root": {
            backgroundColor: "#dcdcdc",
            borderRadius: "4px",
          },
        }}
      />

      {[userRoles.SURGEON].includes(values.role) && (
        <>
          <h5 className={styles.h5}>District Information</h5>
          <DropdownField
            name="district"
            label="District Information"
            dropDownList={districts.map((d) => ({ _id: d, name: d }))}
            itemFieldValue="_id"
            itemFieldLabel="name"
            value={values?.district}
            onChange={inputHandler}
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "#dcdcdc",
                borderRadius: "4px",
              },
            }}
          />
        </>
      )}

      <Box sx={{ m: "10px 0" }}>
        <Checkbox
          checked={values.hasReReferPermission}
          name="hasReR"
          onChange={(e) =>
            setFieldValue("hasReReferPermission", e.target.checked)
          }
        />
        <p className="form-label font-size-14 font-weight-medium cursor-pointer text-danger">
          Does have referral permission?
        </p>
      </Box>

      <UserAddTitleAndInput
        title="Contact Email*"
        name="email"
        placeholder="Contact Email*"
        disabled={!!id}
      />

      <UserAddTitleAndInput title="Phone" name="phone" placeholder="Phone" />
    </>
  );
};

export default UserFormStepOne;
